if (!customElements.get('promo-video')) {
  customElements.define(
    'promo-video',
    class PromoVideo extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.video = this.querySelector('video');
        this.button = this.querySelector('[data-video-playback-button]');
        this.playIcon = this.querySelector('[data-video-play-icon]');
        this.pauseIcon = this.querySelector('[data-video-pause-icon]');

        if (!this.video || !this.button) return;

        this.isInitialized = true;
        this.button.addEventListener('click', () => this.togglePlayback());
        this.video.addEventListener('play', () => this.updatePlaybackButton());
        this.video.addEventListener('pause', () => this.updatePlaybackButton());

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.pause();
        }

        this.updatePlaybackButton();
      }

      togglePlayback() {
        if (this.video.paused) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      }

      updatePlaybackButton() {
        const isPaused = this.video.paused;
        this.playIcon.hidden = !isPaused;
        this.pauseIcon.hidden = isPaused;
        this.button.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      }
    }
  );
}
